// Fragment "landing (lot L)" — rempli par son lot de retrofit ; fusionné dans ./index.js.
// Convention : clés plates pointées, valeurs dans les 3 langues, jamais vides.
//
// `landing.turnkey.*` / `landing.boosters.*` / `landing.fees.*` / `landing.pkg.*` are the
// Turnkey & Activation, Boosters and Platform-fees sections of the marketing page. They
// carry NO amount: every price on those cards comes from the catalogue rows the server
// returns (`/api/saas/skus`, `/api/saas/boosters`), so a locale string can never state a
// price the product has stopped charging. `landing.pkg.fromPrice` interpolates the already
// formatted amount — the one hazard there is that `interpolate` substitutes via
// String.replace, where a "$1,499" replacement would be read as a capture-group reference
// if this pattern ever gained capture groups; `\{price\}` has none, so `$n` stays literal.
export default {
  fr: {
    "landing.nav.practitionerLoginDesc": "Accès au dashboard de votre cabinet",
    "landing.nav.teamLoginDesc": "Pour @solunary.health",
    "landing.turnkey.eyebrow": "Clé en main & activation",
    "landing.turnkey.titleA": "Nous pouvons tout faire",
    "landing.turnkey.titleB": "à votre place.",
    "landing.turnkey.subtitle": "Installation et reprise de données, en une seule fois. En ligne en une semaine, pas en trois mois.",
    "landing.turnkey.install": "Forfaits d'installation",
    "landing.turnkey.porting": "Reprise de données",
    "landing.turnkey.purchaseNote": "Rien n'est facturé sur cette page : les forfaits d'installation et la reprise de données s'achètent depuis Facturation, dans le tableau de bord de votre cabinet, une fois votre plan actif. Démarrez un plan, ou écrivez-nous et nous cadrons le projet avec vous.",
    "landing.boosters.eyebrow": "Boosters récurrents",
    "landing.boosters.title": "Renforcez votre stack.",
    "landing.boosters.purchaseNote": "Les boosters s'ajoutent et se résilient depuis Facturation, dans le tableau de bord de votre cabinet, à tout moment une fois votre plan actif.",
    "landing.fees.eyebrow": "Frais de plateforme",
    "landing.fees.title": "Vous ne payez qu'en grandissant.",
    "landing.pkg.mostPopular": "Le plus choisi",
    "landing.pkg.free": "Gratuit",
    "landing.pkg.fromPrice": "À partir de {price}",
    "landing.pkg.oneTime": "paiement unique",
    "landing.pkg.ctaSignup": "Créer un compte pour l'ajouter",
    "landing.pkg.ctaAsk": "Poser une question sur ce forfait",
    "landing.pkg.askSubject": "Question au sujet de {item}",
  },
  en: {
    "landing.nav.practitionerLoginDesc": "Access to your practice dashboard",
    "landing.nav.teamLoginDesc": "For @solunary.health",
    "landing.turnkey.eyebrow": "Turnkey & Activation",
    "landing.turnkey.titleA": "We can do it",
    "landing.turnkey.titleB": "all for you.",
    "landing.turnkey.subtitle": "One-time install and data porting. Be live in a week, not three months.",
    "landing.turnkey.install": "Install Packages",
    "landing.turnkey.porting": "Data Porting",
    "landing.turnkey.purchaseNote": "Nothing is charged on this page: install packages and data porting are bought from Billing in your practice dashboard, once your plan is active. Start a plan, or write to us and we will scope it with you.",
    "landing.boosters.eyebrow": "Recurring Boosters",
    "landing.boosters.title": "Boost your stack.",
    "landing.boosters.purchaseNote": "Boosters are added or cancelled from Billing in your practice dashboard, at any time, once your plan is active.",
    "landing.fees.eyebrow": "Platform Fees",
    "landing.fees.title": "Pay only as you grow.",
    "landing.pkg.mostPopular": "Most popular",
    "landing.pkg.free": "Free",
    "landing.pkg.fromPrice": "From {price}",
    "landing.pkg.oneTime": "one-time",
    "landing.pkg.ctaSignup": "Sign up to add it",
    "landing.pkg.ctaAsk": "Ask about this package",
    "landing.pkg.askSubject": "Question about {item}",
  },
  es: {
    "landing.nav.practitionerLoginDesc": "Acceso al panel de tu consulta",
    "landing.nav.teamLoginDesc": "Para @solunary.health",
    "landing.turnkey.eyebrow": "Llave en mano y activación",
    "landing.turnkey.titleA": "Podemos hacerlo",
    "landing.turnkey.titleB": "todo por ti.",
    "landing.turnkey.subtitle": "Instalación y migración de datos, de una sola vez. En línea en una semana, no en tres meses.",
    "landing.turnkey.install": "Paquetes de instalación",
    "landing.turnkey.porting": "Migración de datos",
    "landing.turnkey.purchaseNote": "En esta página no se cobra nada: los paquetes de instalación y la migración de datos se compran desde Facturación, en el panel de tu consulta, una vez que tu plan esté activo. Empieza un plan o escríbenos y lo definimos contigo.",
    "landing.boosters.eyebrow": "Boosters recurrentes",
    "landing.boosters.title": "Potencia tu stack.",
    "landing.boosters.purchaseNote": "Los boosters se añaden y se cancelan desde Facturación, en el panel de tu consulta, en cualquier momento una vez que tu plan esté activo.",
    "landing.fees.eyebrow": "Comisiones de la plataforma",
    "landing.fees.title": "Paga solo mientras creces.",
    "landing.pkg.mostPopular": "El más popular",
    "landing.pkg.free": "Gratis",
    "landing.pkg.fromPrice": "Desde {price}",
    "landing.pkg.oneTime": "pago único",
    "landing.pkg.ctaSignup": "Regístrate para añadirlo",
    "landing.pkg.ctaAsk": "Consultar sobre este paquete",
    "landing.pkg.askSubject": "Consulta sobre {item}",
  },
};
